import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单名称",
      "prop": "formName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入表单名称"
    },
    model: {
      value: _vm.form.formName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "formName", $$v);
      },
      expression: "form.formName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单类型",
      "prop": "category"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择表单类型"
    },
    model: {
      value: _vm.form.category,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "category", $$v);
      },
      expression: "form.category"
    }
  }, _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateName
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "状态",
      "prop": "processStatusName"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: _vm.form.processStatusName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "processStatusName", $$v);
      },
      expression: "form.processStatusName"
    }
  }, _vm._l(_vm.fillStautsList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.itemKey
      }
    }, [_vm._v(" " + _vm._s(item.itemName) + " ")]);
  }), 1)], 1)], 1)], 1), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "发起时间",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "申请流水号",
      "prop": "fillId"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "formatter": function formatter(value) {
        return "".concat(value);
      },
      "parser": function parser(value) {
        return value.replace('.', '');
      },
      "placeholder": "请输入申请流水号"
    },
    model: {
      value: _vm.form.fillId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fillId", $$v);
      },
      expression: "form.fillId"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "概述",
      "prop": "summary"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入概述"
    },
    model: {
      value: _vm.form.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "summary", $$v);
      },
      expression: "form.summary"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": _vm.cz
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.list,
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "taskId",
      fn: function fn(taskId, row) {
        return [_c('div', {
          ref: "popclass"
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "确认取消跟踪该流程吗？",
            "ok-text": "是",
            "cancel-text": "否",
            "id": "btnn",
            "visible": _vm.visible && (row.processInstanceId || row.procInsId) == _vm.visibleId
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.handlepopConfirmConfirm(row);
            },
            "cancel": function cancel($event) {
              return _vm.handlepopConfirmCancel(row);
            },
            "visibleChange": function visibleChange($event) {
              return _vm.handleVisibleChange(row);
            }
          }
        }, [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.toSave(row);
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("../../../assets/img/flag_red.png"),
            "alt": ""
          }
        })])])], 1)];
      }
    }, {
      key: "processStatusName",
      fn: function fn(processStatusName, row) {
        return [row.processStatusName == '草稿' ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : row.processStatusName == '审批中' || '待审批' ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v(" 待审批 ")]) : row.processStatusName == '审批通过' ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v(" 通　过 ")]) : _c('a-tag', {
          staticClass: "tag-orange"
        }, [_vm._v("驳　回")])];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.view(row);
            }
          }
        }, [_vm._v("查看")])], 1)], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };